// removed by extract-text-webpack-plugin
module.exports = {"PromoNavigationItem":"PromoNavigationItem","PromoNavigationItem__link":"PromoNavigationItem__link","PromoNavigationItem__image":"PromoNavigationItem__image","PromoNavigationItem__border":"PromoNavigationItem__border","PromoNavigationItem__heading":"PromoNavigationItem__heading","PromoNavigationItem__heading-pc":"PromoNavigationItem__heading-pc","PromoNavigationItem__heading-mb":"PromoNavigationItem__heading-mb"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/promo-navigation-item/styles.css
// module id = 717
// module chunks = 0 1